import { render, staticRenderFns } from "./RouteConfig.vue?vue&type=template&id=a595fe22&"
import script from "./RouteConfig.vue?vue&type=script&lang=js&"
export * from "./RouteConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports